export default __webpack_public_path__ + "static/android-b0d431e7b7bf98a6ee8eab4240402b22.jpg";